import { render, staticRenderFns } from "./EcOrder.vue?vue&type=template&id=c0c6b82c&scoped=true"
import script from "./EcOrder.vue?vue&type=script&lang=js"
export * from "./EcOrder.vue?vue&type=script&lang=js"
import style0 from "./EcOrder.vue?vue&type=style&index=0&id=c0c6b82c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c6b82c",
  null
  
)

export default component.exports